<template>
    <div class="top_header_ b_border_">
      <div class="w1000_ clearfix_">
        <img class="logo_" :src="logoUrl" />
        <label class="com_">国际领先的保险和投资机构认证平台</label>
        <router-link class="f_r_" :to="{name: 'home'}">返回首页</router-link>
      </div>
    </div>
</template>
<script>
import api from '@/utils/api'
export default {
    data () {
        return {
          logoUrl:'',
          servicePhone:'',
          storeName:''
        }
    },
    mounted (){
      this.fetchData()
    },
    methods:{
      fetchData(){
        let userId = 771596  //后台配置用户:GDSC01 GDsc01-01
        if(window.location.href.indexOf('run4wd') > -1){
          userId = 590584
        }
        api.queryStore({
              userId:userId
          }).then(res => res.data).then(data => {
            if(data.returnCode === '00' && data.content!=''){
                this.logoUrl=data.content.coreStoreDto.logoUrl
                this.servicePhone=data.content.coreStoreDto.servicePhone
                this.storeName=data.content.coreStoreDto.storeName
            }
        })
      }
    }
}
</script>
<style lang="scss" scoped>
  .top_header_ {
    background: rgba(255, 255, 255, 0.8);
    padding: 0 0 0 43px;
    height: 67px;
    line-height: 67px;
    text-align: left;
    .com_ {
      color: #333333;
      font-size: 15px;
      margin-left: 42px;
    }

    .logo_ {
      width: 102px;
      height: 50px;
      object-fit:cover;
    }
  }
</style>
